export default __webpack_public_path__ + "static/logo-740d989112488f49f2019690dba937fb.svg";